<template>
	<v-card elevation="0" class="review-conts-detail">
		<v-sheet
			v-if="item && item.images"
			id="scroll-threshold-example"
			class="overflow-y-auto"
			:class="{'no-image': item.images.length === 0}"
			:height="pageHeight()"
		>
			<div class="review-carousel-box">
				<!-- 캐로셀과 도움이돼요 영역 묶음 -->
				<v-carousel
					:show-arrows="item.images.length > 1 ? true : false"
					hide-delimiter-background
					hide-delimiters
					height="auto"
					class="gallery-carousel"
					@change="pageIndex($event)"
				>
					<template v-slot:prev="{ on, attrs }" class="gallery-box">
						<v-btn
							color="rgba(0, 0, 0, 0.32)"
							v-bind="attrs"
							v-on="on"
							class="gallery-prev"
						></v-btn>
					</template>
					<template v-slot:next="{ on, attrs }">
						<v-btn
							color="rgba(0, 0, 0, 0.32)"
							v-bind="attrs"
							v-on="on"
							class="gallery-next"
						></v-btn>
					</template>
					<v-carousel-item v-for="(image, i) in item.images" :key="i">
						<v-responsive
							:aspect-ratio="4 / 5"
							class="align-center"
							align="center"
							:max-height="maxImageHeight()"
						>
							<video-player
								v-if="videoShowFlags[i] && currIdx - 1 == i"
								class="video-player-box"
								ref="videoPlayer"
								:options="playerOptions(image)"
								:playsinline="true"
								customEventName="customstatechangedeventname"
								@loadeddata="onPlayerLoadeddata($event, i)"
							>
							</video-player>
							<v-img
								v-else
								class="my-auto"
								:src="imageSrc(image)"
								contain
								:max-height="maxImageHeight()"
								align="left"
							>
								<v-btn
									v-if="videoFlag(image.type)"
									fab
									small
									class="btn-video-play"
									@click="play(i)"
								>
									<v-icon>mdi-play</v-icon>
								</v-btn>
							</v-img>
						</v-responsive>
					</v-carousel-item>
				</v-carousel>
				<!-- 추천 0일때는 숫자 비노출 처리 필요 -->
				<!-- 도움이 돼요 + 신고하기 -->
				<v-card-text class="py-0">
					<v-row no-gutters align="center" class="rcmdReport">
						<div class="helpful-box">
							<v-btn
								:class="this.thumbIcon"
								small
								min-width="32"
								min-height="32"
								rounded
								@click="rcmdSubmit()"
							>
								도움이 돼요
								<span v-if="this.item.rcmdCnt != 0"
									>{{ this.item.rcmdCnt }}
								</span>
							</v-btn>
						</div>
						<v-spacer></v-spacer>
						<div v-if="'Y' == isLogin && this.myRevwFlg != 'Y'" class="review-report">
							<router-link :to="reportLink()"
								>신고하기
							</router-link>
						</div>
						<div v-if="'Y' != isLogin" class="review-report">
							<button @click="goToLogin()">신고하기</button>
						</div>
					</v-row>
				</v-card-text>
				<!-- 도움이 돼요 -->
			</div>

			<div
				class="text-center"
				v-show="item.images.length > 1 ? true : false"
			>
				<v-chip
					class="ma-2"
					color="rgba(0, 0, 0, 0.4)"
					text-color="white"
					small
				>
					{{ item.currIdx }} / {{ item.images.length }}
				</v-chip>
			</div>

			<v-card-text>
				<v-row align="center" class="my-0 mx-0">
					<v-rating
						:value="item.stars"
						color="#fd8f03"
						dense
						half-increments
						readonly
						size="15"
						class="icon-star pa-0"
					></v-rating>
					<!-- 디자인에 점수 없어서 주석처리 
                    <div class="review-num ml-1" style="color:rgba(17, 17, 17, 0.6);"> 
                        {{ item.stars }}
                    </div>-->
					<div class="grey--text writer">
						{{ item.regrId }}
					</div>
					<div class="grey--text date">{{ item.regDtm }}</div>
				</v-row>
				<v-row class="my-0 mx-0 mt-0">
					<div v-if="item.revwTyp == 'OneMonnRevw'" class="month-bdg">
						한달사용
					</div>
				</v-row>

				<div class="my-0">
					<div v-if="item.optNm" class="desc-option">
						구매옵션 : {{ item.optNm }}
					</div>

					<!-- <div v-if="item.evalInfoList" class="desc-sm">
						<span v-for="(d, i) in item.evalInfoList" :key="i">
							{{ d.evalItmNm }} : {{ d.evalItmVal }}
						</span>
					</div> -->

					<div v-if="item.revwPrsn" class="desc-box desc-row">
						<span v-if="item.revwPrsn.prsnHgt"
							><span class="tit">키</span>
							{{ item.revwPrsn.prsnHgt }}</span
						>
						<span v-if="item.revwPrsn.prsnUps"
							><span class="tit">상의</span>
							{{ item.revwPrsn.prsnUps }}</span
						>
						<span v-if="item.revwPrsn.prsnDws"
							><span class="tit">하의</span>
							{{ item.revwPrsn.prsnDws }}</span
						>
					</div>
				</div>
				<!-- 
        <div v-if="item.evalInfoList" class="my-4">
          <span v-for="(d, i) in item.evalInfoList" :key="i">
            {{ d.evalItmNm }} : {{ d.evalItmVal }}
          </span>
        </div> -->

				<!-- <div v-if="item.revwPrsn" class="my-4">
          <span v-if="item.revwPrsn.prsnHgt">키 : {{ item.revwPrsn.prsnHgt }}<br /></span>
          <span v-if="item.revwPrsn.prsnUps">상의 : {{ item.revwPrsn.prsnUps }}<br /></span>
          <span v-if="item.revwPrsn.prsnDws">하의 : {{ item.revwPrsn.prsnDws }}<br /></span>
        </div> -->

				<v-row class="mx-0 my-4"
					><div v-html="item.prdrevwBody" class="desc-txt"></div
				></v-row>

				<div v-if="item.evalInfoList" class="desc-box desc-column">
					<div
						v-for="(d, i) in item.evalInfoList"
						:key="i"
						class="desc-item"
					>
						<span class="tit">{{ d.evalItmNm }}</span>
						{{ d.evalItmVal }}
					</div>
				</div>
			</v-card-text>
		</v-sheet>
		<!-- </v-bottom-navigation> -->
	</v-card>
</template>

<script>
import store from "@/store";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { APP_URL } from "../api/index";

export default {
	components: {
		videoPlayer,
	},
	data() {
		return {
			item: store.state.detail,
			firstPlay: false,
			videoShowFlags: {},
		};
	},
	computed: {
		thumbIcon() {
			return this.item
				? this.item.rcmdFlg == "Y"
					? "rcmdBtn icon-thumb-on"
					: "rcmdBtn icon-thumb"
				: "";
		},
		myRevwFlg() {
			return store.state.items ? (store.state.items[this.currIdx]
				? store.state.items[this.currIdx].myRevwFlg 
				: "N" ): store.state.detail ? store.state.detail.myRevwFlg : "N";
		},
		zindex() {
			if (
				this.item && this.item.images &&
				this.item.images.length > 0 &&
				this.item.images[this.currIdx - 1].type == "VIDEO"
			) {
				return "z-index:100; bottom: 46px; !important;";
			} else {
				return "";
			}
		},
		currIdx() {
			return this.item.currIdx;
		},
		isLogin() {
			return this.item.loginYn;
		},
	},
	methods: {
		pageIndex(index) {
			this.item.currIdx = index + 1;
		},
		pageHeight() {
			return window.innerHeight - 44;
		},
		maxImageHeight() {
			return Math.min(window.innerWidth, 600) / (4 / 5);
		},
		reportLink() {
			return (
				"/report/" +
				this.$route.params.prdcd +
				"/" +
				this.$route.params.messageId
			);
		},
		imageSrc(item) {
			return "IMAGE" == item.type ? item.path : item.thumbPath;
		},
		videoFlag(type) {
			return "VIDEO" == type;
		},
		play(index) {
			this.firstPlay = true;
			this.videoShowFlags[index] = true;
			this.$forceUpdate();
		},
		playerOptions(item) {
			return {
				muted: true,
				language: "kr",
				sources: [
					{
						type: "video/mp4",
						src: item.path,
					},
				],
				poster: item.thumbPath,
			};
		},
		onPlayerLoadeddata(player, index) {
			if (this.firstPlay && this.currIdx - 1 == index) {
				this.firstPlay = false;
				player.play();
			}
		},
		async rcmdSubmit() {
			if ("Y" == this.item.loginYn) {
				const submitRcmd = await store.dispatch("SUBMIT_RCMD", {
					prdcd: this.$route.params.prdcd,
					messageId: this.$route.params.messageId,
					myRevwFlg: this.myRevwFlg,
					rcmdFlg: store.state.detail.rcmdFlg,
					oppstFlg: "N",
				});
				this.goodRevwClick();
			} else {
				var loginUrl =
					"https://m.gsshop.com/member/logIn.gs?returnurl=" +
					this.item.retUrl;
				if ("Y" == this.item.appYn) {
					loginUrl = "toapp://login?param=" + location.href;
				}
				location.href = loginUrl;
			}
		},
		isOneMonthRevw() {
			return this.item.revwTyp == "OneMonnRevw";
		},
		goodRevwClick() {
			sendAmplitudeCodeAction(
				store.state.prdcd,
				"",
				"",
				"상품평_목록_" +
					(this.isOneMonthRevw() ? "한달" : "일반") +
					"_도움돼요",
				true
			);
		},
		goToLogin() {
			var loginUrl =
				APP_URL + "/member/logIn.gs?returnurl=" + location.href;
			if ("Y" == store.state.appYn) {
				loginUrl = "toapp://login?param=" + location.href;
			}
			location.href = loginUrl;
		},
	},
};
</script>

<style lang="scss">
.review-conts-detail {
	font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Roboto",
		"Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
		"Helvetica Neue", "Malgun Gothic", helvetica, sans-serif;
	border-radius: 0 !important;
	max-width: 600px;
	margin: 0 auto;
	.overflow-y-auto {
		.v-card__text {
			margin: 0 0 16px;
		}
		&.no-image {
			display: flex;
			flex-direction: column;
			.review-carousel-box { order: 2; }
			.v-card__text { order: 1; }
		}
	}
	.review-report a {
		font-size: 14px;
		color: #999;
		text-decoration: none;
	}
	.desc-option {
		margin-top: 8px;
		font-size: 13px;
		color: #76768e;
		letter-spacing: -0.3px;
		overflow: hidden;
		line-height: 16px;
	}
	.desc-box {
		font-size: 13px;
		color: #76768e;
		letter-spacing: -0.3px;
		.tit {
			padding-right: 4px;
			color: #9595b2;
		}
	}
	.desc-row {
		margin-top: 4px;
		font-size: 13px;
		color: #76768e;
		line-height: 16px;
		.tit {
			padding-right: 4px;
			color: #9595b2;
		}
		> span {
			position: relative;
			padding: 0 4px;
			&:first-child {
				padding-left: 0;
				&:before {
					width: 0;
				}
			}
			&:before {
				content: "";
				position: absolute;
				top: 2px;
				left: 0;
				display: block;
				width: 1px;
				height: 12px;
				background: #f5f6fa;
			}
		}
	}
	.desc-column {
		.desc-item {
			color: #76768e;
			line-height: 16px;
			font-weight: 600;
		}
		.tit {
			display: inline-block;
			min-width: 56px;
			font-weight: normal;
		}
	}

	.help-txt {
		font-size: 14px;
		line-height: 56px;
		letter-spacing: -0.4px;
		color: rgba(25, 25, 35, 0.64);
	}
	.icon-thumb {
		border: 1px solid #d2d4e5;
		border-radius: 6px !important;
		text-align: center;
		background-color: #fff;
		padding: 0 12px 0 8px !important;
		&.v-btn {
			color: #191923 !important;
			background: #fff;
			box-shadow: none;
			&::before {
				position: relative !important;
				display: inline-block;
				width: 16px;
				height: 16px;
				opacity: 1;
				color: #191923;
				border: solid 1px #d2d4e5;
				background-color: transparent;
				border: 0;
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath d='M14 10.667c0 1.654-1.346 3-3 3H5v-5.66l1.7-2.21c.127-.166.215-.362.253-.567l.544-2.897H8c.551 0 1 .449 1 1v2.334h-.5a.5.5 0 0 0 0 1H13c.551 0 1 .448 1 1v3zm-12 3h2v-5H2v5zm11-8h-3V3.333a2 2 0 0 0-2-2h-.78a.667.667 0 0 0-.655.544L5.97 5.046a.339.339 0 0 1-.064.141L4 7.667H1.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5H11a4 4 0 0 0 4-4v-3a2 2 0 0 0-2-2z' fill='%23111' fill-rule='evenodd'/%3E%3C/svg%3E");
				background-repeat: no-repeat;
				background-position: center;
			}
			&.v-btn--active {
				&:not(:hover):before {
					opacity: 1 !important;
				}
			}
		}
		span {
			font-weight: 600;
			font-size: 13px;
			letter-spacing: -0.3px;
		}
	}
	.icon-thumb-on {
		border: 1px solid #d2d4e5;
		border-radius: 6px !important;
		text-align: center;
		background-color: #fff;
		padding: 0 12px 0 8px !important;
		&.v-btn {
			color: #191923 !important;
			background: #fff;
			box-shadow: none;
			&::before {
				position: relative !important;
				display: inline-block;
				width: 16px;
				height: 16px;
				opacity: 1;
				color: #191923;
				// border: solid 1px rgba(124, 124, 159, 0.22);
				background-color: transparent;
				border: 0;
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath d='m13.805 4.198-.003-.003a.667.667 0 0 0-.942 0L6.344 10.72 3.14 7.515a.667.667 0 0 0-.942 0l-.003.003a.667.667 0 0 0 0 .943l3.676 3.675.002.002c.26.26.683.26.943 0l.002-.002 6.987-6.996a.667.667 0 0 0 0-.942' fill='%231B1B23' fill-rule='evenodd'/%3E%3C/svg%3E");
			}
			&.v-btn--active {
				&:not(:hover):before {
					opacity: 1 !important;
				}
			}
		}
		span {
			font-weight: 600;
			font-size: 13px;
			letter-spacing: -0.3px;
		}
	}

	.v-item-group.v-bottom-navigation {
		box-shadow: none !important;
		border-top: 1px solid #e0e2eb;
		border-radius: 0;
	}
	.v-sheet.v-card {
		border-radius: 0;
	}

	.review-num {
		line-height: 16px;
	}
	.chip-use {
		height: 16px;
		padding: 0 8px;
		border-radius: 8px;
		color: #ee1f60;
		text-align: center;
		font-size: 12px;
		line-height: 16px;
		background: #fdf2f6;
		letter-spacing: -0.3px;
		font-weight: bold;
	}

	.v-chip.v-size--x-small {
		height: 20px;
		border-radius: 10px;
		font-size: 12px;
	}
	.v-window__prev,
	.v-window__next {
		background: none;
		margin: 0;
	}
	.gallery-prev {
		min-width: 48px !important;
		height: 48px !important;
		padding: 0 !important;
		border-radius: 0;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='25'%3E%3Cpath d='m7.222 11.84 7.456-7.22a.793.793 0 0 1 1.095 0 .734.734 0 0 1 0 1.06l-6.94 6.72 6.94 6.72a.734.734 0 0 1 0 1.06.793.793 0 0 1-1.095 0l-7.456-7.22A.729.729 0 0 1 7 12.4a.73.73 0 0 1 .22-.56' fill='%23FFF' fill-rule='evenodd' opacity='.8'/%3E%3C/svg%3E") !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		box-shadow: none;
		background-color: transparent !important;
	}
	.gallery-next {
		min-width: 48px !important;
		height: 48px !important;
		padding: 0 !important;
		border-radius: 0;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='25'%3E%3Cpath d='M16.778 11.84 9.322 4.62a.793.793 0 0 0-1.095 0 .734.734 0 0 0 0 1.06l6.94 6.72-6.94 6.72a.734.734 0 0 0 0 1.06.793.793 0 0 0 1.095 0l7.456-7.22A.729.729 0 0 0 17 12.4a.73.73 0 0 0-.22-.56' fill='%23FFF' fill-rule='evenodd' opacity='.8'/%3E%3C/svg%3E") !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		box-shadow: none;
		background-color: transparent !important;
	}

	.video-js {
		width: 100% !important;
		padding-top: 125%;
		height: auto !important;
		.vjs-big-play-button {
			width: 64px;
			height: 64px;
			margin: -32px 0 0 -32px;
			border-radius: 50%;
			top: 50%;
			left: 50%;
			background: rgba(25, 25, 35, 0.32) !important;
			border: 0;

			.vjs-icon-placeholder:before {
				content: "";
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'%3E%3Cdefs%3E%3Cfilter id='26xporz9oa' color-interpolation-filters='auto'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cg%3E%3Cg filter='url(%2326xporz9oa)' transform='translate(-585.000000, -2349.000000) translate(415.000000, 2117.000000) translate(156.000000, 218.000000)'%3E%3Cg%3E%3Cpath fill='%231B1B23' d='M7.111 7.119v19.896c0 2.192 2.356 3.562 4.24 2.466l17.103-9.948c1.884-1.096 1.884-3.836 0-4.933L11.35 4.652c-1.883-1.096-4.239.274-4.239 2.467' transform='translate(14.933333, 14.933333)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				background-position: center;
			}
		}
	}
	.btn-video-play {
		width: 64px;
		height: 64px;
		background: rgba(25, 25, 35, 0.32) !important;
		box-shadow: none;
		margin: -32px 0 0 -32px;
		top: 50%;
		left: 50%;
		.v-icon {
			width: 34px;
			height: 34px;
		}
		.mdi-play::before {
			content: "";
			width: 34px;
			height: 34px;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'%3E%3Cdefs%3E%3Cfilter id='26xporz9oa' color-interpolation-filters='auto'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cg%3E%3Cg filter='url(%2326xporz9oa)' transform='translate(-585.000000, -2349.000000) translate(415.000000, 2117.000000) translate(156.000000, 218.000000)'%3E%3Cg%3E%3Cpath fill='%231B1B23' d='M7.111 7.119v19.896c0 2.192 2.356 3.562 4.24 2.466l17.103-9.948c1.884-1.096 1.884-3.836 0-4.933L11.35 4.652c-1.883-1.096-4.239.274-4.239 2.467' transform='translate(14.933333, 14.933333)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
		}
	}
	.v-chip.v-size--small {
		height: 20px;
		border-radius: 10px;
		font-size: 12px;
	}
	.writer,
	.date {
		color: #9595b2 !important;
		font-size: 13px;
		margin-left: 8px;
		letter-spacing: -0.3px;
	}

	.desc-wrap {
		display: block !important;
	}
	.month-bdg {
		display: inline-block;
		width: auto;
		height: 20px;
		margin-right: 4px;
		padding: 2px 4px;
		border-radius: 4px;
		font-size: 12px;
		line-height: 16px;
		letter-spacing: -0.3px;
		text-align: center;
		color: #ee1f60;
		background-color: #fdf2f6;
	}
	.desc-txt {
		font-size: 14px;
		line-height: 20px;
		letter-spacing: -0.4px;
		color: #424252;
	}

	// 캐로셀
	.gallery-carousel {
		background-color: #f5f6fa;
	}
}
.mdi-star::before {
	content: "";
	width: 16px;
	height: 16px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath d='m8.71 1.52 1.36 4.3 4.512-.034c.726-.005 1.03.927.438 1.35l-3.67 2.623 1.428 4.28c.23.69-.564 1.266-1.15.834L8 12.194l-3.63 2.68c-.584.431-1.378-.145-1.147-.835l1.427-4.28L.98 7.136c-.592-.423-.288-1.355.438-1.35l4.51.035L7.29 1.52c.22-.693 1.2-.693 1.42 0' fill='%23FD8F03' fill-rule='evenodd'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
}
.mdi-star-outline::before {
	content: "";
	width: 16px;
	height: 16px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath d='m8.71 1.52 1.36 4.3 4.512-.034c.726-.005 1.03.927.438 1.35l-3.67 2.623 1.428 4.28c.23.69-.564 1.266-1.15.834L8 12.194l-3.63 2.68c-.584.431-1.378-.145-1.147-.835l1.427-4.28L.98 7.136c-.592-.423-.288-1.355.438-1.35l4.51.035L7.29 1.52c.22-.693 1.2-.693 1.42 0' fill='%23EAECF5' fill-rule='evenodd'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
}
.v-carousel__controls {
	background: blue !important;
}

.review-carousel-box {
	position: relative;
	.rcmdReport {
		padding: 8px 0;
		border-bottom: 1px solid #eaecf5;
	}
	.helpful-box {
		// position: absolute;
		// bottom: 16px;
		// left: 16px;
	}
	.review-report {
		color: #76768e;
		a {
			color: #76768e;
		}
	}
}

.v-responsive__content {
	height: width (4 / 5);
}
</style>